import {UnresolvedTimelineEvent} from '@ots-frontend/ots-data';
import {Text, ThemeIcon} from '@mantine/core'
import {useTranslation} from "react-i18next";
import {FormattedDateTime} from '../../date/FormattedDateTime/FormattedDateTime';
import {IconCircleXFilled} from "@tabler/icons-react";

type Props = {
    event: UnresolvedTimelineEvent;
};

export const UnresolvedTimelineItemTitle = (props: {}) => {
    const {t} = useTranslation(["common"])
    return <>{t("common.entity.dispatchrequest.timeline.unresolved.title", "Unresolved")}</>
}

export const UnresolvedTimelineItemBullet = (props: {}) => {
    return (
        <ThemeIcon
            size={22}
            color="dispatch-request-canceled"
            radius="xl"
        >
            <IconCircleXFilled size={12}/>
        </ThemeIcon>
    )
}

export const UnresolvedTimelineItem = (props: Props) => {
    const {event} = props;

    const {t} = useTranslation(["common"])

    return (
        <>
            <Text color="dimmed" size="sm">
                {t("common.entity.dispatchrequest.timeline.unresolved.summary", "{{personName}} unresolved the dispatch request.", {
                    personName: event.person ? event.person : t("common.shared.user", "User")
                })}
            </Text>

            <Text size="xs" mt={4}>
                <FormattedDateTime date={event.date}/>
            </Text>
        </>
    );
};

UnresolvedTimelineItem.Title = UnresolvedTimelineItemTitle
UnresolvedTimelineItem.Bullet = UnresolvedTimelineItemBullet;
